import React from 'react';
import {LoaderThreeDots} from '@ael/shared-components-library';
import './Loader.scss';

export const Loader: React.FC = () => (
  <div className="content-wrapper-loader">
    <LoaderThreeDots />
  </div>
);
